import QueryContext from '../QueryContext';
import api from '../index';

const swapMatchFetchers = {
  getSwapMatchesByProfileId: (context: QueryContext) => {
    const {brandId, profileId, network} = context.meta || {};

    if (!brandId || !profileId) {
      throw new Error('Both brandId and profileId are required');
    }

    const params = network ? {network} : {};
    return api.get(`/brands/${brandId}/profiles/${profileId}/swap_matches`, {
      params,
    });
  },
};

export default swapMatchFetchers;
